import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete } from "@mui/lab";
import { Grid, TextField } from '@mui/material';
import { ButtonAdd } from './general/mini_components';
import { ReduxStore } from '../constants/types';
import { BillableCombo } from '../pages/hospital/Billing/types';
import { pushBillables, getBillableComboAction } from '../redux/actions/billingActions';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';

export const BillableComboSelector: React.FC<LocalizeContextProps> = (props) => {
    const [comboSelected, setComboSelected] = useState<BillableCombo | null>(null);
    const dispatch = useDispatch();
    
    const billableCombos = useSelector((state:ReduxStore) => 
        state.billing.data.billableCombos ? state.billing.data.billableCombos : []
    );
    const loadingBillables = useSelector((state:ReduxStore) => state.billing.loading);
    const uuidInvestigation = useSelector((state:ReduxStore) => 
        state.investigations.currentInvestigation?.uuid
    );
    const idBillingInfo = useSelector((state:ReduxStore) => 
        state.investigations.currentInvestigation?.billingInfo?.id
    );

    useEffect(() => {
        if (billableCombos.length === 0 && uuidInvestigation && idBillingInfo) {
            dispatch(getBillableComboAction(uuidInvestigation, idBillingInfo));
        }
    }, [dispatch, uuidInvestigation, idBillingInfo, billableCombos.length]);

    const addBillablesCombo = async () => {
        if(comboSelected){
            dispatch(pushBillables(comboSelected.billables));
            setComboSelected(null);
        }
    };

    const selectCombo = (selectedCombo: BillableCombo | null) => {
        if(selectedCombo === null) return;
        
        const comboFound = billableCombos.find((combo) => combo.id === selectedCombo.id);
        if(comboFound){
            setComboSelected(selectedCombo);
        }
    };

    if (loadingBillables) {
        return (
            <Grid container item xs={6} style={{ display:'flex', paddingTop: '1rem' }}>
                <TextField 
                    label="Loading combos..." 
                    disabled
                    style={{ width: 300 }}
                    color="secondary"
                    variant="outlined" 
                />
            </Grid>
        );
    }

    if (billableCombos.length === 0) return null;

    return (
        <Grid container xs={12} style={{ display: 'flex', paddingTop: '1rem' }}>
            <Grid container item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                <Autocomplete
                    disabled={loadingBillables}
                    value={comboSelected}
                    options={billableCombos}
                    onChange={(_, newValue) => selectCombo(newValue)}
                    getOptionLabel={(option) => option.name}
                    style={{ width: 300 }}
                    renderInput={(params) => 
                        <TextField 
                            {...params} 
                            label={<Translate id="hospital.billing.bill.selectors.select_combo" />}
                            error={false}
                            helperText={null} 
                            color="secondary"
                            variant="outlined" 
                        />
                    }
                />
                {comboSelected && (
                    <ButtonAdd style={{ marginLeft: '0.5rem' }} onClick={addBillablesCombo} />
                )}
            </Grid>
        </Grid>
    );
};

export default withLocalize(BillableComboSelector); 